import React from 'react';
import { FileVideo, BookCheck, BookOpenCheck, LineChart } from 'lucide-react';
import './FeatureSection.css';

const FeatureCard = ({ icon: Icon, title, description }) => (
  <div className="p-4 flex gap-6 rounded-lg hover:shadow-md hover:scale-105 transition-all duration-300">
    <Icon className="w-12 h-12 bg-blue-100 p-3 rounded-lg shrink-0" />
    <div>
      <h3 className="text-gray-800 text-xl font-semibold mb-3">{title}</h3>
      <p className="text-gray-600 text-sm">{description}</p>
    </div>
  </div>
);

const FeatureSection = () => {
  const features = [
    {
      icon: FileVideo,
      title: "Training",
      description: "Boost your exam prep with Finhaat Gurukul materials, including video tutorials and PDFs, designed for all learning levels to help you succeed and master essential concepts effectively."
    },
    {
      icon: BookCheck,
      title: "Mock",
      description: "Practice with our realistic mock tests and quizzes, designed to simulate the exam experience and help you identify areas for improvement, boosting your confidence and readiness."
    },
    {
      icon: BookOpenCheck,
      title: "Examination",
      description: "Take your final step with our structured exams, designed to assess your knowledge and readiness. Experience a real exam environment to boost your confidence and performance."
    },
    {
      icon: LineChart,
      title: "Performance",
      description: "Track your progress with detailed performance reports that highlight strengths and areas for improvement. Gain insights to tailor your study plan and maximize your exam success."
    }
  ];

  return (
    <div className="feature-section-container-homepage max-w-6xl mx-auto font-sans p-4">
      <h2 className="text-gray-800 sm:text-4xl feature-section-container-homepage-h2 font-extrabold text-center mb-16">Discover Our Exclusive Features</h2>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 max-md:max-w-lg mx-auto gap-12">
        {features.map((feature, index) => (
          <FeatureCard key={index} {...feature} />
        ))}
      </div>
    </div>
  );
};

export default FeatureSection;